import { graphql } from "@opensea/graphql"
import { TokenPriceFragment } from "@/components/price/TokenPrice.fragment"

export const TraitOffersFilterTableRowFragment = graphql(
  `
    fragment TraitOffersFilterTableRow on TraitOfferAggregateTotal {
      traitType
      traitValue
      traitPercent
      bestOfferPrice {
        token {
          unit
        }
        ...TokenPrice
      }
      totalValue {
        token {
          unit
        }
        ...TokenPrice
      }
    }
  `,
  [TokenPriceFragment],
)
